// ── 출퇴근 관리 ☰ 'IP 관리' 창 (2026-10-23) ──────────────────────────────────────
// 사용자: "IP 주소관리를 출퇴근관리에 넣어보려고" → ☰ 메뉴 항목, 누르면 창. 왼쪽 메뉴 'IP 관리' 페이지는 없앴다.
//   창 안 = 옛 IP 관리 화면 세 부분(최근 활동·IP 연결 목록·별칭) 그대로. 범위는 창을 연 출퇴근 화면이 넘긴다:
//   본사 /api/admin/ip-scope/hq · 회사 .../company/:code · 통합 .../menu/:id (서버 routes/ip-scope.route.js).
import React from 'react';
import Modal from '../../../components/Modal';
import IpManagement from './IpManagement';

/**
 * @param {boolean}  open
 * @param {function} onClose
 * @param {string}   apiBase     범위 주소
 * @param {boolean}  allowShared 공용 IP 등록 가능(통합 출퇴근 관리만)
 */
export default function IpManagementModal({ open, onClose, apiBase, allowShared = false }) {
  return (
    <Modal open={open} title="IP 관리" onClose={onClose} width="min(1040px, calc(100vw - 48px))" mobileSheet>
      <div style={{ fontSize: 12, color: 'var(--text-muted)', marginBottom: 10 }}>출퇴근 허용 IP를 관리합니다.</div>
      {open && <IpManagement apiBase={apiBase} allowShared={allowShared} />}
    </Modal>
  );
}
